import { useEffect, useRef, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/api";
import { DesktopLinks, MobileLinks } from "./navigation/NavLinks";

export const Nav = ({ onTip }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const scrollTimer = useRef(null);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => { window.removeEventListener("scroll", onScroll); clearTimeout(scrollTimer.current); };
  }, []);
  const go = (selector) => {
    setMenuOpen(false);
    clearTimeout(scrollTimer.current);
    scrollTimer.current = setTimeout(() => scrollToId(selector), menuOpen ? 150 : 0);
  };
  return <>
    <header className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${scrolled ? "glass border-b border-line" : "bg-transparent"}`} data-testid="main-navigation">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <button data-testid="nav-logo-button" onClick={() => go("#top")} className="flex items-center gap-2.5 group" aria-label="Retour en haut"><Logo size={32} /><span className="font-display text-xl tracking-wide group-hover:text-pink-400 transition-colors">PEPE <span className="text-cyan-400">AVS</span></span></button>
        <DesktopLinks go={go} onTip={onTip} />
        <button data-testid="nav-menu-toggle" className="lg:hidden p-2 text-slate-200" onClick={() => setMenuOpen((value) => !value)} aria-expanded={menuOpen} aria-label="Menu">{menuOpen ? <X size={26} /> : <Menu size={26} />}</button>
      </div>
    </header>
    <AnimatePresence>{menuOpen && <MobileLinks go={go} onTip={() => { setMenuOpen(false); onTip(); }} />}</AnimatePresence>
  </>;
};